import React, { useContext } from 'react';
import { Route } from 'react-router-dom';
import { AuthContext } from "../contexts/Authentication/AuthStateProvider";

const PublicRoute = ({component: Component, ...rest}) => {
	const { state:authState, dispatch } = useContext(AuthContext);

    return (
        // restricted = false meaning public route
        // restricted = true meaning restricted route
        /*<Route {...rest} render={props => (
            authState.isAuthenticated && restricted ?
                <Redirect to="/home" />
            : <Component {...props} />
        )} />*/

        /*TODO*/

        <Route {...rest} render={props => (
          <>
           <Component {...props} {...rest} />
          </>
        )} />
    );
};

export default PublicRoute;